var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refund"},[_c('div',{staticClass:"state"},[_c('strong',[_vm._v("退款流程")]),_c('span',[_vm._v(_vm._s(_vm.Isitcomplete))])]),_c('div',{staticClass:"refund-see",on:{"click":_vm.clickSee}},[_vm._v("查看")])])
}
var staticRenderFns = []

export { render, staticRenderFns }